/**
 * Build-time team-scan visibility flag (AC-1.2 / AC-1.4). Fail-open by design:
 * the panel stays visible on anything except the exact opt-out sentinel
 * `'off'` — unset, empty, a typo, `'0'`, `'no'`, `'false'` all resolve to
 * visible. A config mistake must degrade toward *more* visibility, never less.
 *
 * The backing env var is declared once below (never constructed — it
 * grep-maps to a build-time declaration passed by the deploy workflow's
 * `vars.` entry, mirroring `VITE_IDENTITY_PROVIDER`) and re-exported so
 * tests can stub it without a second literal copy (NFR-1: the var name
 * appears in exactly 4 places repo-wide). Single source of truth: every
 * call site (both `PhaseView.tsx` mounts) imports `TEAM_SCAN_ENABLED` —
 * never re-derives it inline.
 */

/** Name of the build-time env var backing this flag. */
export const TEAM_SCAN_ENV_VAR = 'VITE_TEAM_SCAN_ENABLED';

export const TEAM_SCAN_ENABLED: boolean = import.meta.env[TEAM_SCAN_ENV_VAR] !== 'off';
